/* ==========================================================================
   LALTERNATIVA - Seconda foto sfogliabile col dito nelle card prodotto
   Compagno di assets/las-card-swipe.css. Caricato da layout/theme.liquid.
   23/10/2026 - tema V1.8 - riscritto da capo.

   COSA FACEVA PRIMA E PERCHE' E' STATO BUTTATO. La prima versione gestiva il
   gesto a mano: ascoltava touchstart/touchmove/touchend sulla card, muoveva
   scrollLeft a ogni spostamento del dito e alla fine faceva scattare la foto
   piu' vicina. Funzionava nelle prove ma sul telefono di Diego no, e ogni
   giro di verifica costava una prova sul suo iPhone. Il gesto scritto a mano
   e' anche sempre peggiore di quello del telefono: niente inerzia, niente
   rimbalzo, niente distinzione automatica tra tocco e trascinamento.

   COSA FA ADESSO: niente gesti. Lo scorrimento e' quello nativo del browser,
   gia' acceso dal CSS (overflow-x:auto + scroll-snap). L'unica cosa che lo
   impediva era il link che il tema stende sopra tutta la card: non sta dentro
   la striscia, quindi toccandolo il telefono non trova nessuno scorrimento
   orizzontale da muovere. Il CSS lo toglie dal percorso del dito e questo
   file rimette un link dentro ogni foto e uno sotto il testo. Risultato:
   il trascinamento scorre (col rimbalzo e l'inerzia veri), il tocco apre la
   scheda prodotto, e non c'e' piu' nessun gesto nostro da far quadrare.

   I link aggiunti sono aria-hidden e tabindex -1: per i lettori di schermo e
   per Google la card ha sempre un solo link, quello originale del tema.

   LA FOTO BIANCA. La seconda immagine resta ritagliata fuori dalla striscia
   finche' non la si porta in vista, quindi il caricamento pigro del tema non
   la fa mai partire, e per di piu' il tema la tiene a visibility:hidden
   perche' sul computer la accende l'hover. Qui la si accende a mano, senza
   mai toccare width/height: scriverli quando il riquadro e' ancora alto zero
   la fa scaricare e disegnare alta zero, cioe' bianca (errore fatto il 22/10).

   DOVE NON SI APPLICA: dentro .f-swiper e .flickity-enabled, cioe' le vetrine
   che scorrono gia' di lato, dove due scorrimenti annidati si ruberebbero il
   gesto. La' il link originale resta attivo e la card e' come prima.

   PER TOGLIERLO: non caricare piu' questo file e il suo CSS da
   layout/theme.liquid. Nessun altro file dipende da qui.
   ========================================================================== */

(function () {
  'use strict';

  var LIMITE = 767;

  function suTelefono() {
    var w = window.innerWidth;
    return w > 0 && w <= LIMITE;
  }

  function dentroVetrina(el) {
    return !!(el.closest('.f-swiper') || el.closest('.flickity-enabled'));
  }

  /* Accende le immagini della striscia senza mai scrivere width/height. */
  function accendiFoto(striscia) {
    var foto = striscia.querySelectorAll('responsive-image');
    for (var i = 0; i < foto.length; i++) {
      var ri = foto[i];
      var im = ri.querySelector('img');
      if (!im) continue;
      /* ripara un eventuale danno lasciato dalle versioni precedenti */
      if (im.getAttribute('width') === '0') im.removeAttribute('width');
      if (im.getAttribute('height') === '0') im.removeAttribute('height');
      /* il tema le tiene invisibili e le accende col mouse: qui non c'e' */
      ri.style.setProperty('visibility', 'visible', 'important');
      im.style.setProperty('visibility', 'visible', 'important');
      if (ri.hasAttribute('intersecting')) continue;
      if (!ri.clientWidth) continue;
      ri.setAttribute('intersecting', 'true');
      im.sizes = Math.round(ri.clientWidth) + 'px';
      im.loading = 'eager';
    }
  }

  function copri(contenitore, indirizzo, classe) {
    if (contenitore.querySelector(':scope > .' + classe)) return;
    var a = document.createElement('a');
    a.className = classe;
    a.setAttribute('href', indirizzo);
    a.setAttribute('aria-hidden', 'true');
    a.setAttribute('tabindex', '-1');
    contenitore.appendChild(a);
  }

  function prepara(card) {
    var striscia = card.querySelector('.product-card__image-wrapper');
    if (!striscia || dentroVetrina(striscia)) return;
    var link = card.querySelector('a.full-width-link.product-card__link');
    if (!link) return;
    var indirizzo = link.getAttribute('href');
    if (!indirizzo) return;

    var foto = striscia.querySelectorAll(':scope > .product-card__image');
    for (var i = 0; i < foto.length; i++) copri(foto[i], indirizzo, 'las-foto-link');

    var testo = card.querySelector('.product-card__info');
    if (testo) copri(testo, indirizzo, 'las-info-link');

    accendiFoto(striscia);
    card.setAttribute('data-las-swipe', '1');
  }

  function passa() {
    if (!suTelefono()) return;
    var cards = document.querySelectorAll('.product-card:not([data-las-swipe])');
    for (var i = 0; i < cards.length; i++) prepara(cards[i]);
  }

  function avvia() {
    passa();
    /* le card arrivano anche dopo: filtri, pagina successiva, ricerca */
    if (window.MutationObserver) {
      var attesa = null;
      new MutationObserver(function () {
        clearTimeout(attesa);
        attesa = setTimeout(passa, 120);
      }).observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('resize', function () { setTimeout(passa, 200); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
